export default function BasketballIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      {/* Backboard with shooter's square */}
      <rect x="10" y="4" width="44" height="28" rx="3" fill="#CFE6FA" fillOpacity="0.28" stroke="#F4F7FB" strokeWidth="2.5" />
      <rect x="24" y="14" width="16" height="12" fill="none" stroke="#F4F7FB" strokeWidth="2" />
      {/* Net */}
      <path
        d="M18 34 L23 52 L41 52 L46 34 M23 34 L27 52 M32 34 L32 52 M41 34 L37 52 M20 41 H44 M22 47 H42"
        fill="none"
        stroke="#F4F7FB"
        strokeWidth="1.8"
        strokeLinejoin="round"
        strokeOpacity="0.9"
      />
      {/* Ball dropping through */}
      <circle cx="32" cy="30" r="9" fill="#E06A1F" />
      <path d="M23.2 30 H40.8 M32 21 V39 M25.6 23.8 Q30 30 25.6 36.2 M38.4 23.8 Q34 30 38.4 36.2" fill="none" stroke="#3A1606" strokeWidth="1.5" />
      <circle cx="29" cy="26.5" r="2.4" fill="#FFFFFF" fillOpacity="0.3" />
      {/* Front of the rim over the ball */}
      <path d="M15 34 Q32 40 49 34" fill="none" stroke="#FF5A1F" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}
